import React from 'react';
import styled from 'styled-components';
import { Button } from 'components/Button';
import useDropdown from 'components/dropdown/hooks/useDropdown';
import MultiSelectCount from './MultiSelectCount';

const StyledConfirmButton = styled(Button)`
    width: 100%;
`;

export default function MultiSelectConfirmButton({ children, onClick, ...restProps }) {
    const { hide } = useDropdown();

    const handler = (e) => {
        if (onClick) {
            onClick(e);
        }
        hide();
    };

    return (
        <StyledConfirmButton {...restProps} onClick={handler}>
            {children}
            <MultiSelectCount />
        </StyledConfirmButton>
    );
}
